import React from 'react';
import { motion } from "motion/react";

const Footer: React.FC = () => {
    const containerVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                staggerChildren: 0.1,
                delayChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
            },
        },
    };

    return (
        <footer className="bg-white dark:bg-black border-t border-gray-200/50 dark:border-gray-800/50 text-gray-900 dark:text-white">
            <motion.div 
                className="max-w-8xl mx-auto px-8 py-16"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    <motion.div variants={itemVariants}>
                        <h3 className="text-2xl font-serif font-medium mb-6">NightSync</h3>
                        <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-6">Your key to the world's most exclusive nightlife. Book tables and tickets, effortlessly.</p>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <h4 className="font-medium mb-4 text-gray-800 dark:text-gray-200">Discover</h4>
                        <div className="space-y-2 text-gray-600 dark:text-gray-400">
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">New York</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">London</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">Ibiza</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">All Cities</a>
                        </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <h4 className="font-medium mb-4 text-gray-800 dark:text-gray-200">Support</h4>
                        <div className="space-y-2 text-gray-600 dark:text-gray-400">
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">FAQ</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">Booking Policy</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">Contact Us</a>
                        </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <h4 className="font-medium mb-4 text-gray-800 dark:text-gray-200">Company</h4>
                        <div className="space-y-2 text-gray-600 dark:text-gray-400">
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">About Us</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">Careers</a>
                            <a href="#" className="block hover:text-gray-900 dark:hover:text-white transition-colors">Press</a>
                        </div>
                    </motion.div>
                </div>
                <motion.div 
                    className="border-t border-gray-200 dark:border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between"
                    variants={itemVariants}
                >
                    <p className="text-gray-500 dark:text-gray-500 text-sm">© 2025 NightSync. All rights reserved.</p>
                    <div className="flex items-center gap-8 text-sm text-gray-500 dark:text-gray-400 mt-4 md:mt-0">
                        <a href="#" className="hover:text-gray-900 dark:hover:text-white transition-colors">Privacy Policy</a>
                        <a href="#" className="hover:text-gray-900 dark:hover:text-white transition-colors">Terms of Service</a>
                    </div>
                </motion.div>
            </motion.div>
        </footer>
    );
};

export default Footer;
